import { GetBillingService } from '~/domain/usecases/billing/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import { UnexpectedError, NotFound, Forbidden } from '~/domain/errors';
import '~/infra/global/variables';

export class RemoteGetBillingService implements GetBillingService {
  private readonly url: string;

  private readonly httpClient: HttpClient<GetBillingService.Model>;

  constructor(url: string, httClient: HttpClient<GetBillingService.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  get = async (
    params: GetBillingService.Params,
  ): Promise<GetBillingService.Model> => {
    let query = '';

    Object.entries(params.query).forEach(([key, value]) => {
      if (value) query += `${key}=${value}&`;
    });

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${params.orgId}/billing/services?${query}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new UnexpectedError();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
